export default __webpack_public_path__ + "static/page-404-main-image-3e5d8d8b7611e55c110807e4ea22eb47.svg";